
export const getLocale = () => {
  return navigator.language.indexOf('fr') !== -1 ? 'fr' : 'en';
};